import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { PosMarketCatalogDto, PosMarketConnectedCatalogItemDto, PosMarketplaceAvailabilityDto } from "../dto";

@Injectable({ providedIn: "root" })
export class PosMarketplaceService {
  protected serviceUrl = "posMarketplace";

  constructor(protected api: ApiService) {}

  getAvailability(): Observable<PosMarketplaceAvailabilityDto> {
    return this.api.get<PosMarketplaceAvailabilityDto>(`${this.serviceUrl}/availability`);
  }

  getCatalog(): Observable<PosMarketCatalogDto[]> {
    return this.api.get<PosMarketCatalogDto[]>(`${this.serviceUrl}/catalog`);
  }

  getConnectedCatalogItems(): Observable<PosMarketConnectedCatalogItemDto[]> {
    return this.api.get<PosMarketConnectedCatalogItemDto[]>(`${this.serviceUrl}/catalog/items/connected`);
  }
}
